module.exports = __webpack_public_path__ + "img/home2.48d8500c.png";